import { render, staticRenderFns } from "./NavV2.vue?vue&type=template&id=ec6dd9c8&scoped=true"
import script from "./NavV2.vue?vue&type=script&lang=ts"
export * from "./NavV2.vue?vue&type=script&lang=ts"
import style0 from "./NavV2.vue?vue&type=style&index=0&id=ec6dd9c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec6dd9c8",
  null
  
)

export default component.exports